/**
 * Trækker enhedskoden ud af det, der blev scannet eller tastet.
 *
 * QR-mærkatet indeholder en hel URL (".../e/K7M2QX9P"), men den kan ikke sendes
 * som et led i API-stien - kodede skråstreger afvises af routingen. Derfor pilles
 * koden ud her, før opslaget. Backenden gør det samme som sikkerhedsnet
 * (DeviceCode.Normalize), så de to sider ikke kan komme til at være uenige.
 *
 * Der gættes bevidst ikke på forvekslede tegn (0/O, 1/I): et forkert gæt ville
 * åbne den forkerte enhed. Se docs/DECISIONS.md beslutning 024.
 */
const LENGTH = 8
const ALPHABET = '23456789ABCDEFGHJKMNPQRSTVWXYZ'

export function normalizeDeviceCode(value: string): string {
  let text = value.trim()

  // Er det en URL fra et mærkat, er koden det sidste led.
  const lastSlash = text.lastIndexOf('/')
  if (lastSlash >= 0 && lastSlash < text.length - 1) {
    text = text.slice(lastSlash + 1)
  }

  const query = text.indexOf('?')
  if (query >= 0) {
    text = text.slice(0, query)
  }

  return text.replace(/[\s-]/g, '').toUpperCase()
}

/** Ser strengen ud som en enhedskode? Bruges til at afvise fremmede QR-koder tidligt. */
export function isDeviceCode(value: string): boolean {
  return value.length === LENGTH && [...value].every((c) => ALPHABET.includes(c))
}
